import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { CheckBox, Button } from 'Components';
import './CheckBoxDropDown.css';

const CheckBoxDropDown = props => (
  <div className="checkbox-drop-down">
    <div className="checkbox-drop-down__all">
      <CheckBox checked={props.isAllChecked} onClick={props.handleSelectAll} />
      <span>{i18n.t('common:All')}</span>
    </div>
    {props.data.length !== 0 && props.data.map((item, i) => (
      <div key={item.name} className="checkbox-drop-down__row">
        <div>
          <Button onClick={e => props.handleOpenClick(e, i)}><i className="material-icons">{item.opened ? 'remove' : 'add'}</i></Button>
          <CheckBox onClick={e => props.handleRowCheckBoxClick(e, i)} checked={item.Checked} />
          <span>{item.name === '' ? 'Parameters' : item.name}</span>
        </div>
        {item.children !== 0 ? (item.opened && item.children.map((child, index) => (
          <div key={child.ParmName} className="checkbox-drop-down__row__child">
            <div>
              <CheckBox
                checked={child.Checked}
                onClick={e => props.handleChildCheckBoxClick(e, i, index)}
              />
              <span>{child.ParmName}</span>
            </div>
          </div>
        ))) : (item.opened &&
          <div className="checkbox-drop-down__row__child">
            <div>
              <span>{i18n.t('reportForms:NoParameters')}</span>
            </div>
          </div>
          )
        }
      </div>
))}
  </div>
);

CheckBoxDropDown.propTypes = {
  handleOpenClick: PropTypes.func,
  handleChildCheckBoxClick: PropTypes.func,
  handleRowCheckBoxClick: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    checked: PropTypes.bool,
    opened: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      checked: PropTypes.bool,
    })),
  })),
  isAllChecked: PropTypes.bool,
  handleSelectAll: PropTypes.func,
};

export default CheckBoxDropDown;



// WEBPACK FOOTER //
// ./src/components/CheckBoxDropDown/CheckBoxDropDown.jsx